import React from 'react';
import { Input } from 'reactstrap';
import { styles, columns } from './Configuration';
import clsx from 'clsx';

const getRowClassName = (row, cor) => clsx(row === -1 ? 'headerCell' : 'rowCell', !cor ? 'evenRow' : 'oddRow');

export const Column = ({ style, name, cell, rowId, colId, row, onChange, onKeyPress, onBlur, onPaste, onKeyDown, selection, readonly }) => (
    <div
        className={clsx(getRowClassName(rowId, row ? row.cor : false), 'cell', { centeredCell: colId > 2 })}
        style={style}
        onMouseDown={(e) => selection.onMouseDown(e, rowId, colId)}
        onMouseEnter={(_) => selection.onMouseEnter(rowId, colId)}
        onMouseUp={(_) => selection.onMouseUp(rowId, colId)}
        onKeyDown={onKeyDown}
        id={`inicio2-row${rowId}-col${colId}`}
        key={name}
        tabIndex={'0'}
    >
        {cell(row, { i: rowId, line: row, column: name, onChange, onKeyPress, onBlur, onPaste, readonly })}
    </div>
);

const reducer = (accumulator, currentValue) => accumulator + parseFloat(currentValue);

export const CellHeader = ({ id, column, style }) => (
    <div className={clsx('headerCell', 'evenRow', 'centeredCell')} id={id} key={column.name} style={style}>
        {column.label.split('\n').map((x, index) => (
            <span style={styles.bold} key={index}>
                {x}
                <br />
            </span>
        ))}
    </div>
);

export const CellSubHeader = ({ column, id, columnIndex, data, style }) => {
    return (
        <div className={clsx('headerCell', 'evenRow', 'centeredCell')} id={id} key={column.name} style={style}>
            <Total data={data} column={column} i={columnIndex} width={column.width} />
        </div>
    );
};

const Total = ({ column, data, i, width }) => {
    if (i === 0) return <span style={styles.bold}>{'Total: '}</span>;

    if (!column.sum || data.length === 0) return null;

    const value = Math.round(
        data
            .map((x) => x[column.name])
            .filter((x) => x)
            .reduce(reducer, 0)
    );

    return <span style={{ ...styles.bold, width: width }}>{value}</span>;
};

export const renderBodyCell = (rowIndex, columnIndex, key, style, data, onChange, onKeyPress, onBlur, onPaste, selection, readonly) => {
    const row = data[rowIndex];
    const column = columns[columnIndex];

    if (rowIndex === 0) return <CellHeader id={'header' + columnIndex} column={column} key={key} style={style} />;

    if (rowIndex === 1)
        return <CellSubHeader id={'header' + columnIndex} column={column} columnIndex={columnIndex} data={data} key={key} style={style} />;

    return (
        <Column
            key={key + column.name}
            style={style}
            {...column}
            rowId={rowIndex}
            colId={columnIndex}
            row={row}
            onChange={onChange}
            onKeyPress={onKeyPress}
            onBlur={onBlur}
            onPaste={onPaste}
            onKeyDown={(e) => selection.onKeyDown(e, rowIndex, columnIndex, data.length, columns.length)}
            selection={selection}
            readonly={readonly}
        />
    );
};

export const CustomInput = ({ i, line, column, onChange, onKeyPress, onBlur, onPaste, style, readonly }) => {
    if (readonly) return line[column] || '';

    return (
        <Input
            key={column}
            type='text'
            pattern='[0-9]*'
            id={column}
            placeholder=''
            value={line[column] || ''}
            className='col-sm-12 form-control-sm'
            onChange={(e) => onChange(e, line, i)}
            onKeyPress={(e) => onKeyPress(e, line, i)}
            onBlur={(e) => onBlur(e, line, i)}
            style={style}
            {...(onPaste && { onPaste: (e) => onPaste(column, e, i) })}
            autoComplete='off'
        />
    );
};

export const CustomAltMan = ({ line }) =>
    line.alteradoManual && (
        <div className='centered'>
            <i className='fa fa-pencil fa-sm' />
        </div>
    );

export const CustomColumnQuantPc = ({ line, render }) => {
    if ((line.conjunto && line.conjunto === 'N') || (line.conjuntoFilhoTipo && line.conjuntoFilhoTipo === 'V')) return line.qtdProgramada;

    return <CustomInput {...{ line, column: 'qtdProgramada', ...render }} />;
};

export const CustomColumnPorcAnt = ({ line, render }) => {
    if ((line.conjunto && line.conjunto === 'N') || (line.conjuntoFilhoTipo && line.conjuntoFilhoTipo === 'V')) return line.qtdProgramada;

    return <CustomInput {...{ line, column: 'percAnt', ...render }} />;
};

export const CustomColumnPorcAntVendaFutura = ({ line, render }) => {
    if ((line.conjunto && line.conjunto === 'N') || (line.conjuntoFilhoTipo && line.conjuntoFilhoTipo === 'V')) return line.qtdProgramada;

    return <CustomInput {...{ line, column: 'percAntVendaFutura', ...render }} />;
};

export const CustomColumnPorcEstSeg = ({ line, render }) => {
    return <CustomInput {...{ line, column: 'percEstoqueSeg', ...render }} />;
};
